//
// PickedNodeInfo.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseUIModel";

var PickedNodeInfo = createModule("commons::PickedNodeInfo", ["commons::PropertyOwner","commons::BaseModel","commons::BaseUIModel"], EventDispatcher, [
    ,
    {
        detailIndex: 3,
        nodeID: 3,
    },
    ,
    ,
    ,
    {
        _create: [4,3,3],
    },
    ,
]);
export default PickedNodeInfo;
